import React, { Component } from 'react';

class Weather extends Component {
	render() {
		return (
			<div className="weather-frame">
				<p id= 'weatherMessage' className="hidden">Brighton is <span id='temperatureDisplay'>{this.props.data.weatherTemperature}</span> expect <span id='forecastDisplay'>{this.props.data.weatherConditions}</span>.</p>
				<p id= 'loading'>&#9632;</p>				
			</div>
		);
	}
}

export default Weather;


// WEBPACK FOOTER //
// ./src/Components/Weather/Weather.js